import PropTypes from 'prop-types';
import React from 'react';
import {
  ButtonGroup,
  Button,
  Modal,
} from 'react-bootstrap';
import AgentDetail from './AgentDetail';

class AgentDetailModal extends React.Component {

  render() {
    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.props.agent.first_name} {this.props.agent.last_name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AgentDetail
              agent={this.props.agent}
            />
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </div>
    );
  }
}


AgentDetailModal.propTypes = {
  agent: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default AgentDetailModal;



// WEBPACK FOOTER //
// src/routes/agency/components/AgentDetailModal.js